import { createToastInterface } from 'vue-toastification'
import type { PluginOptions, ToastInterface } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default defineNuxtPlugin((nuxtApp) => {
  const options: PluginOptions = {
    position: 'top-center',
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    transition: {
      enter: 'Vue-Toastification__slideBlurred',
      leave: 'Vue-Toastification__fade'
    },

    // ✅ 关键：加自定义类，方便我们单独控制定位与层级
    containerClassName: 'lb-toast-container',
    toastClassName: 'lb-toast',
    newestOnTop: true
  }

  const toast: ToastInterface = createToastInterface(options)
  nuxtApp.vueApp.config.globalProperties.$toast = toast
  return { provide: { toast } }
})
